import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import TicketMentionList from '../components/tickets/TicketMentionList';

/**
 * @param {() => object[]} getItems
 * @returns {object}
 */
export function createTicketMentionSuggestion(getItems) {
  return {
    char: '@',
    allowSpaces: true,
    items: ({ query }) => {
      const items = getItems() || [];
      const needle = (query || '').trim().toLowerCase();
      if (!needle) return items.slice(0, 12);
      return items
        .filter(
          (item) =>
            item.label.toLowerCase().includes(needle) ||
            (item.searchText || '').includes(needle),
        )
        .slice(0, 12);
    },
    render: () => {
      let component;
      let popup;

      return {
        onStart: (props) => {
          component = new ReactRenderer(TicketMentionList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          popup = tippy(document.body, {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start',
            zIndex: 9999,
          });
        },
        onUpdate(props) {
          component?.updateProps(props);
          if (!props.clientRect) return;
          popup?.[0]?.setProps({
            getReferenceClientRect: props.clientRect,
          });
        },
        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            popup?.[0]?.hide();
            return true;
          }
          return component?.ref?.onKeyDown?.(props) ?? false;
        },
        onExit() {
          popup?.[0]?.destroy();
          component?.destroy();
        },
      };
    },
  };
}
